import EformBaseService from '../../../../services/EformBaseService'

export default class SbfiReportingService extends EformBaseService {

  constructor() {
    super('wbf/sbfi/reporting')
  }
}
